import { AfterViewInit, Component, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { HtmlQrcodeScanner } from '../html-qrcode-scanner/html-qrcode-scanner.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { Html5QrcodeSupportedFormats } from 'html5-qrcode';
import { QrDimensionFunction, QrDimensions } from 'html5-qrcode/esm/core';
import { TranslocoModule } from '@jsverse/transloco';
import { CameraPurposeNoticeComponent } from 'app/modules/shared/containers/camera-purpose-notice/camera-purpose-notice.component';

@Component({
    selector: 'scan-qrcode',
    imports: [MatButtonModule, MatIcon, HtmlQrcodeScanner, TranslocoModule, CameraPurposeNoticeComponent],
    templateUrl: './scan-qrcode.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './scan-qrcode.component.scss'
})
export class ScanQrcodeComponent implements AfterViewInit {
    @ViewChild('htmlQrcodeScanner') htmlQrcodeScanner!: HtmlQrcodeScanner;

    /** The scanner (and with it the browser's permission prompt) is only started after the user has read what the camera is for (BSI O.Plat_3). */
    started = false;

    types = [
        Html5QrcodeSupportedFormats.QR_CODE,
        Html5QrcodeSupportedFormats.AZTEC,
    ];

    qrbox: QrDimensions | QrDimensionFunction = {
        width: 400,
        height: 400,
    };

    constructor(
        // private qrcode: NgxScannerQrcodeService,
        public matDialogRef: MatDialogRef<ScanQrcodeComponent>
    ) {}

    ngAfterViewInit(): void {
        // this.action.isReady.subscribe((res: any) => {
        //     // this.handle(this.action, 'start');
        // });
    }

    handleScanSuccess(e) {
        console.log('sucess: ', e);
        this.matDialogRef.close(e || null);
    }

    handleScanError(e) {
        // console.log('err: ', e);
        this.matDialogRef.close(null);
    }

    close() {
        this.htmlQrcodeScanner?.html5QrCode?.stop();
        this.matDialogRef.close(null);
    }
}
